module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centerx"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('em', [_vm._v("Other Books by Rebecca McClanahan")])]), _vm._v(" "), _c('p', {
    staticClass: "imagec"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "centery"
  }, [_vm._v("Mother Tongue")]), _vm._v(" "), _c('p', {
    staticClass: "centery"
  }, [_vm._v("Mrs. Houdini")]), _vm._v(" "), _c('p', {
    staticClass: "centery"
  }, [_vm._v("One Word Deep: Lectures and Readings")]), _vm._v(" "), _c('p', {
    staticClass: "centery"
  }, [_vm._v("The Intersection of X and Y")]), _vm._v(" "), _c('p', {
    staticClass: "centery"
  }, [_vm._v("Word Painting: A Guide to Writing More Descriptively")]), _vm._v(" "), _c('p', {
    staticClass: "centery"
  }, [_vm._v("Naked as Eve")]), _vm._v(" "), _c('p', {
    staticClass: "centery"
  }, [_vm._v("Write Your Heart Out")]), _vm._v(" "), _c('p', {
    staticClass: "centery"
  }, [_vm._v("The Riddle Song and Other Rememberings")]), _vm._v(" "), _c('p', {
    staticClass: "centery"
  }, [_vm._v("Deep Light: New and Selected Poems")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-759e2e48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm1.vue
// module id = 60
// module chunks = 0